import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { FeatureFlagsService } from "../../service/feature-flags.service";
import { exhaustMap, map, of, retry } from "rxjs";
import { catchError } from "rxjs/operators";
import {
  GET_FEATURE_FLAG_TELEADVICE_ERROR,
  LOAD_FEATURE_FLAG_TELEADVICE,
  SET_FEATURE_FLAG_TELEADVICE,
  GET_FEATURE_FLAG_HILLS_POST_ADOPTION_DTC_ERROR,
  LOAD_FEATURE_FLAG_HILLS_POST_ADOPTION_DTC,
  SET_FEATURE_FLAG_HILLS_POST_ADOPTION_DTC,
  LOAD_FEATURE_FLAG_INSURANCE,
  SET_FEATURE_FLAG_INSURANCE,
  GET_FEATURE_FLAG_INSURANCE_ERROR,
} from "./feature-flags.actions";

@Injectable()
export class FeatureFlagsEffects {
  constructor(private actions: Actions,
    private featureFlagsService: FeatureFlagsService) {
  }

  loadFeatureFlags$ = createEffect(() => {
    return this.actions.pipe(
      ofType(LOAD_FEATURE_FLAG_TELEADVICE),
      exhaustMap(() => this.featureFlagsService.getFeatureFlagTeleAdvice()
        .pipe(
          map(teleAdvice => ({
            type: SET_FEATURE_FLAG_TELEADVICE,
            featureFlag: teleAdvice
          })),
          retry(3),
          catchError(error => of({
            type: GET_FEATURE_FLAG_TELEADVICE_ERROR,
            errorCode: error.status,
            errorMessage: error.message
          }))
        )
      )
    );
  })

  loadHillsPostAdoptionDTCFeatureFlag$ = createEffect(() => {
    return this.actions.pipe(
      ofType(LOAD_FEATURE_FLAG_HILLS_POST_ADOPTION_DTC),
      exhaustMap(() => this.featureFlagsService.getFeatureFlagHillsPostAdoptionDTC()
        .pipe(
          map(hillsPostAdoptionDTC => ({
            type: SET_FEATURE_FLAG_HILLS_POST_ADOPTION_DTC,
            featureFlag: hillsPostAdoptionDTC
          })),
          retry(3),
          catchError(error => of({
            type: GET_FEATURE_FLAG_HILLS_POST_ADOPTION_DTC_ERROR,
            errorCode: error.status,
            errorMessage: error.message
          }))
        )
      )
    );
  })

  loadInsuranceFeatureFlag$ = createEffect(() => {
    return this.actions.pipe(
      ofType(LOAD_FEATURE_FLAG_INSURANCE),
      exhaustMap(() =>
        this.featureFlagsService.getFeatureFlagInsurance().pipe(
          map((insurance) => ({
            type: SET_FEATURE_FLAG_INSURANCE,
            featureFlag: insurance,
          })),
          retry(3),
          catchError((error) =>
            of({
              type: GET_FEATURE_FLAG_INSURANCE_ERROR,
              errorCode: error.status,
              errorMessage: error.message,
            })
          )
        )
      )
    );
  });
}
